import React from "react";
import classnames from "classnames";
import Box from "@material-ui/core/Box";
import playListItemStyles from "../../football/styles/PlayListItem.styles";
import { usePlayTeamPossession } from "../../football/components/PlayListItem";
import {
	getFormattedTime,
	getPlayNumber
} from "../../football/components/utils/PlayUtils";

import StreamStyles from "../styles/StreamStyles";

const StreamMarkerFbOption = ({ play, gameConfig }) => {
	const streamClasses = StreamStyles();
	const classes = playListItemStyles({ team: usePlayTeamPossession(play) });

	return play ? (
		<Box className={streamClasses.streamMkrFbOptionContainer} id={play.id}>
			<div className={classes.playNumber}>
				<span>{getPlayNumber(play.index)}</span>
			</div>
			<div className={classnames(classes.square, classes.time)}>
				<span>{getFormattedTime(play.time, gameConfig, play.period)}</span>
			</div>
			<div
				className={classnames(streamClasses.streamMkrFbOptionTitle, classes.title)}
			>
				{play.title}
			</div>
		</Box>
	) : null;
};

export default StreamMarkerFbOption;
